// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.vendorsandpartners.insurancecompanies.VoidInsuranceCreditRequest */
/* istanbul ignore next */
@GandalfModel
export class VoidInsuranceCreditRequest extends GandalfModelBase {

	@GandalfLabel('Reason')
	@GandalfValidator({ sizeString: { message: 'Reason cannot be longer than 235 characters', minLength: 0, maxLength: 235 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfLabel('Credit')
	@GandalfValidator({ notNull: { message: 'Credit is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	creditId!: number;

	@GandalfLabel('Practice Insurance Company')
	@GandalfValidator({ notNull: { message: 'Practice Insurance Company is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	practiceInsuranceCompanyId!: number;

}
